// extracted by mini-css-extract-plugin
export var deleteModal = "_h9-0";